/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAddMember = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.503 3.989l-.006-1-1.5.008-.008-1.5-1 .006.008 1.5-1.5.008.006 1 1.5-.008.008 1.5 1-.006-.008-1.5 1.5-.008zM8.082 9.51H6.018a4.495 4.495 0 00-3.19 1.336c-.846.855-1.322 1.947-1.324 3.156l.5.498H12.01l.496-.5c-.002-1.207-.392-2.298-1.237-3.152A4.495 4.495 0 008.082 9.51zM8.609 8.488a2.858 2.858 0 11-3.176-4.752A2.858 2.858 0 018.61 8.488z"
}));

export default SvgAddMember;